import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FunctionComponent } from 'react';

interface ComplianceTermItemProps {
  icon: FunctionComponent;
  title: string;
  text: string;
}

const complianceTermItemStyles = {
  root: {
    display: 'flex',
    columnGap: '12px',
  },
  iconWrapper: {
    py: '6px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 1,
  },
  contentTitle: {
    fontSize: {
      xs: '18px',
      sm: '20px',
    }
  },
  contentText: {
    lineHeight: {
      xs: '24px',
      sm: '26px',
    }
  },
} as const;

export function ComplianceTermItem({
  icon: Icon,
  title,
  text,
}: ComplianceTermItemProps) {
  return (
    <Box sx={complianceTermItemStyles.root} component={'article'}>
      <Box component={'span'} sx={complianceTermItemStyles.iconWrapper}>
        <Icon />
      </Box>
      <Box sx={complianceTermItemStyles.content}>
        <Typography sx={complianceTermItemStyles.contentTitle} component={'h3'} variant="h6">
          {title}
        </Typography>
        <Typography sx={complianceTermItemStyles.contentText} variant="body1">{text}</Typography>
      </Box>
    </Box>
  );
}
